// extracted by mini-css-extract-plugin
module.exports = {"body":"_d123d17","topPadding":"_ca8e98e","info":"_7000389","scrollableArea":"_f9ed4a9","mobileDevice":"_abf5291","ownLine":"_abf9830","button":"_f27e955"};